import { render, staticRenderFns } from "./SummaryAmerican.vue?vue&type=template&id=dc873d66&scoped=true"
import script from "./SummaryAmerican.vue?vue&type=script&lang=js"
export * from "./SummaryAmerican.vue?vue&type=script&lang=js"
import style0 from "./SummaryAmerican.vue?vue&type=style&index=0&id=dc873d66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc873d66",
  null
  
)

export default component.exports